import React from 'react';

export default class SupplementNotFound extends React.PureComponent {
  render() {
    return <div className='supplement-not-found'>The requested supplement was not found.</div>;
  }
}
